import styled from 'styled-components'

export const CardsRowWrapper = styled.div`
  width: 100vw;
  height: 100px;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-top: 32px;
  position: relative;
  margin-bottom: 20px;

  @media screen and (max-width: 1024px) {
    margin-top: 27px;
    padding-left: 0;
    padding-right: 0;
  }

  @media screen and (max-width: 768px) {
    margin-top: 16px;
    margin-bottom: 16px;
    height: auto;
  }
`

export const HashtagCard = styled.div`
  width: 240px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 18px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 5px;
  overflow: hidden;

  & span {
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: #ffffff;
    z-index: 3;
  }

  & img,
  & div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    border-radius: 5px;
  }

  & div {
    content: '';
    z-index: 2;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
  }

  @media screen and (max-width: 768px) {
    width: 131px;
    height: 42px;
    margin-right: 8px;

    & span {
      font-weight: bold;
      font-size: 13px;
      line-height: 16px;
    }
  }
`

export const ScrollButton = styled.button`
  width: 42px;
  height: 42px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
  position: absolute;
  right: ${props => (props.back ? 'unset' : '10px')};
  left: ${props => (props.back ? '10px' : 'unset')};
  border: none;
  border-radius: 50%;
  transform: rotate(${props => (props.back ? '-180deg' : '0deg')});
  z-index: 4;

  & img {
    margin-left: 1px;
    margin-top: 3px;
  }

  @media screen and (max-width: 768px) {
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;

    & img {
      height: 6px;
      margin: 0;
    }
  }
`

export const CardsScrollableWrapper = styled.div`
  display: flex;
  padding-left: 37px;
  padding-right: 50px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    padding-left: 12px;
    padding-right: 18px;
  }
`
